export default () => {
	return { flatJson: true };
};
